import { IAuthAdapter } from './IAuthAdapter';
import { ApiResponse } from '../../types/api';
import {
  AuthSession,
  LoginCredentials,
  RegisterDto,
  ForgotPasswordDto,
  ResetPasswordDto,
  ChangePasswordDto,
} from '../../types/auth';
import { ApiClient } from '../apiClient';
import { isDemoMode } from '../../config/backend';

export class GASAuthAdapter implements IAuthAdapter {
  async login(credentials: LoginCredentials): Promise<ApiResponse<AuthSession>> {
    if (isDemoMode()) {
      return {
        success: true,
        data: {
          token: 'demo-gas-session-token-' + Date.now(),
          user: {
            user_id: 'USR-00001',
            name: credentials.email.split('@')[0] || 'System Admin',
            email: credentials.email,
            role: 'ADMIN',
            department_id: 'DEP-001',
            plant_id: 'PLT-001',
          },
          expires_at: new Date(Date.now() + 86400000).toISOString(),
        },
        message: 'Login successful via GAS Auth Adapter',
      };
    }

    return ApiClient.post<AuthSession>('/auth/login', credentials);
  }

  async register(dto: RegisterDto): Promise<ApiResponse<AuthSession>> {
    if (isDemoMode()) {
      return {
        success: true,
        data: {
          token: 'demo-gas-session-token-' + Date.now(),
          user: {
            user_id: 'USR-00002',
            name: dto.name,
            email: dto.email,
            role: 'DEPARTMENT_USER',
          },
          expires_at: new Date(Date.now() + 86400000).toISOString(),
        },
        message: 'Registration successful via GAS Auth Adapter',
      };
    }

    return ApiClient.post<AuthSession>('/auth/register', dto);
  }

  async logout(): Promise<ApiResponse<void>> {
    if (isDemoMode()) {
      return { success: true, data: undefined, message: 'Logged out successfully' };
    }

    const token = localStorage.getItem('nad_auth_token');
    return ApiClient.post<void>('/auth/logout', { token });
  }

  async getCurrentUser(token: string): Promise<ApiResponse<AuthSession>> {
    if (isDemoMode()) {
      return {
        success: true,
        data: {
          token,
          user: {
            user_id: 'USR-00001',
            name: 'System Admin',
            email: 'admin@nad.com',
            role: 'ADMIN',
          },
          expires_at: new Date(Date.now() + 86400000).toISOString(),
        },
        message: 'Session verified',
      };
    }

    return ApiClient.get<AuthSession>('/auth/me', { headers: { Authorization: `Bearer ${token}` } });
  }

  async forgotPassword(dto: ForgotPasswordDto): Promise<ApiResponse<void>> {
    return ApiClient.post<void>('/auth/forgot-password', dto);
  }

  async resetPassword(dto: ResetPasswordDto): Promise<ApiResponse<void>> {
    return ApiClient.post<void>('/auth/reset-password', dto);
  }

  async changePassword(dto: ChangePasswordDto): Promise<ApiResponse<void>> {
    return ApiClient.post<void>('/auth/change-password', dto);
  }
}
